import { createResourceListQuery } from "queries";
import types from "resources/types";

export const clientFeedbackSurveyQuery = (config = {}) =>
  createResourceListQuery(types.CLIENT_FEEDBACK_SURVEY, {
    url: "/api/v2/client_feedback_survey/",
    ...config,
  });
